/**
 * Free-tier limits live here so every feature reads from a single
 * source of truth. Pro is unlimited.
 */

export const FREE_RECEIPT_LIMIT = 50;
